{
  "certificates": {
    "navigation_title": "Certificates",
    "create_new": "Create Certificate",
    "devices": "Devices",
    "title": "Certificates",
    "new": "Create Certificate",
    "edit": "Edit Certificate",
    "common": "Place info",
    "name": "Name",
    "description": "Description",
    "phone": "Phone",
    "address": "Address",
    "place_picture": "Picture of the place",
    "dialogs": {
      "delete": {
        "title": "Are you sure?",
        "content": "Are you sure you want to delete '%{name}' certificate? You can't undo this action"
      }
    }
  }
}
